import { useState } from "react";
import { Play } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { Reveal, SectionHeading } from "./Reveal";
import { VideoModal } from "./VideoModal";
import { VIDEOS, photoFocus } from "../data/siteData";

export const Videos = () => {
  const { lang, t } = useLanguage();
  const [active, setActive] = useState(null);

  return (
    <section id="videos" className="scroll-mt-20 border-t border-ink-700/60 bg-ink-900/40 py-20 sm:py-28" data-testid="videos-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal>
          <SectionHeading eyebrow={t.videos.eyebrow} title={t.videos.title} testId="videos-heading" />
        </Reveal>

        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {VIDEOS.map((video, i) => (
            <Reveal key={video.id} delay={0.08 * i} className="h-full">
              <div className="flex h-full flex-col border border-ink-700/60 bg-ink-900 transition-colors duration-200 hover:border-kit/50">
                <button
                  data-testid={`video-play-button-${i + 1}`}
                  onClick={() => setActive(video)}
                  className="group relative block aspect-video w-full overflow-hidden bg-ink-950"
                  aria-label={`${t.videos.play}: ${video.title[lang]}`}
                >
                  <img
                    src={video.poster}
                    alt={video.title[lang]}
                    loading="lazy"
                    style={{ objectPosition: photoFocus(video.poster) }}
                    className="h-full w-full object-cover opacity-70 transition duration-500 group-hover:scale-[1.02] group-hover:opacity-90"
                  />
                  <span className="absolute inset-0 flex items-center justify-center">
                    <span className="flex h-16 w-16 items-center justify-center rounded-full border border-kit bg-ink-950/70 text-kit backdrop-blur-sm transition-transform duration-300 group-hover:scale-110">
                      <Play size={22} className="ml-0.5" fill="currentColor" />
                    </span>
                  </span>
                </button>
                <div className="flex items-center justify-between gap-4 p-5">
                  <h3 className="font-display text-xl font-semibold uppercase leading-tight text-white">
                    {video.title[lang]}
                  </h3>
                  <span className="shrink-0 font-mono text-[10px] font-semibold uppercase tracking-[0.15em] text-zinc-500">
                    {t.videos.play}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-4 text-xs text-zinc-500" data-testid="videos-fallback-note">
            {t.videos.note}
          </p>
        </Reveal>
      </div>

      <VideoModal video={active} onClose={() => setActive(null)} />
    </section>
  );
};
